// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DocumentCreateResponseModel {
    'documentGroupId'?: number;
    'intakeLayoutId'?: number;
    'documentFileName'?: string;
    'documentLocation'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DocumentCreateResponseModel>> = [
        {
            "name":     "documentGroupId",
            "baseName": "documentGroupId",
            "type":     "number"
        },
        {
            "name":     "intakeLayoutId",
            "baseName": "intakeLayoutId",
            "type":     "number"
        },
        {
            "name":     "documentFileName",
            "baseName": "documentFileName",
            "type":     "string"
        },
        {
            "name":     "documentLocation",
            "baseName": "documentLocation",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DocumentCreateResponseModel.attributeTypeMap;
    }
}
